<script>
    import {Line} from "vue-chartjs";

    export default {
        name: "LineChart",
        extends: Line,
        props: {
            results: {
                type: Array,
                required: true
            },
        },
        computed: {
            sortedResults() {
                return [...this.results].sort((y1, y2) => y1.year - y2.year);
            },
            labels() {
                return this.sortedResults.map(result => result.year);
            },
            datasets() {
                return [
                    {
                        label: "Celkový čas",
                        borderColor: "#dc3545",
                        backgroundColor: "transparent",
                        data: this.sortedResults.map(result => this.toSeconds(result.total))
                    },
                    {
                        label: "Po kole",
                        borderColor: "gray",
                        backgroundColor: "transparent",
                        data: this.sortedResults.map(result => this.toSeconds(result.afterBike))
                    },
                    {
                        label: "Kolo",
                        borderColor: "#ffbf00",
                        backgroundColor: "transparent",
                        data: this.sortedResults.map(result => this.toSeconds(result.bike))
                    },
                    {
                        label: "Běh",
                        borderColor: "#71ad47",
                        backgroundColor: "transparent",
                        data: this.sortedResults.map(result => this.toSeconds(result.run))
                    },
                    {
                        label: "Plavání",
                        borderColor: "#5c9cd6",
                        backgroundColor: "transparent",
                        data: this.sortedResults.map(result => this.toSeconds(result.swim))
                    }
                ];
            },
            chartData() {
                return {
                    labels: this.labels,
                    datasets: this.datasets
                };
            },
            options() {
                const that = this;
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                callback: function (value) {
                                    return that.formatTime(value);
                                }
                            }
                        }]
                    },
                    elements: {
                      line: {
                          tension: 0
                      }
                    },
                    legend: {
                        position: "right"
                    },
                    tooltips: {
                        callbacks: {
                            // We'll edit the `title` string
                            label: function (item) {
                                const label = that.datasets[item.datasetIndex].label || "";
                                return that.formatTime(item.value) + " (" + label + ")";
                            }
                        }
                    }
                };
            }
        },
        watch: {
            results: {
                handler() {
                    this.rerender();
                }
            }
        },
        mounted() {
            this.rerender();
        },
        methods: {
            rerender() {
                this.renderChart(this.chartData, this.options);
            },
            toSeconds(durationString) {
                const parts = durationString.split(":");
                return parseInt(parts[0]) * 3600 + parseInt(parts[1]) * 60 + parseInt(parts[2]);
            },
            formatTime(seconds) {
                let hours = Math.floor(seconds / 3600);
                seconds = seconds % 3600;
                let minutes = Math.floor(seconds / 60);
                seconds = seconds % 60;

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }

                return `${hours}:${minutes}:${seconds}`;
            }
        }
    };
</script>